<template>
  <div class="exam-question__slide">
    <div class="exam-question__slide__head">
      <h3 class="font-size-20 primary-color-txt font-sanpro-semibold">Sách</h3>
    </div>
    <div class="exam-question__slide__list">
      <swiper v-if="dataSource && dataSource.length > 0" class="swiper" :options="swiperOption" >
        <swiper-slide v-for="(item, index) of dataSource" :key="index">
          <div class="item__wrap position-rel text-center">
            <div class="item__head aspect-ratio aspect-ratio--4-3 bg-transparent">
              <a href="javascript:;" @click="viewQuestionByBook(item)">
                <img class="inner-img border-rd-8" v-lazy="item.imageUrl &&  item.imageUrl !== null ? replaceLink(item.imageUrl): imgHs7"  />
              </a>
            </div>
            <div class="item__body">
              <h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt" @click="viewQuestionByBook(item)">
                <a href="javascript:;"  class="primary-color-txt">
                  {{item.name}}
                </a>
              </h3>
              <p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ item.manufactureYear }}</p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev question_slide_prev" slot="button-prev"></div>
        <div class="swiper-button-next question_slide_next" slot="button-next"></div>
      </swiper>
      <p v-else class="secondary-color-txt font-size-18 text-center">Không có dữ liệu phù hợp</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { APP_CONFIG } from "@/utils/constants"
import { STORE_KEY } from './../../_store/constants'
import { replaceImageResize } from '@/helpers/functions'

const imgHs7 = require('@/assets/img/HS-7.jpg')

export default {
  name: 'ModalQuestionsInBook',
  props: {
    dataSource: Array
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      imgHs7,
      cdnUrl: APP_CONFIG.cdnUrl,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 1,
        // loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.question_slide_next',
          prevEl: '.question_slide_prev'
        }
      },
    }
  },
  computed: {
    
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetBookIdFilterQuestions']),

    viewQuestionByBook (data) {
      if (data.bookId) {
        this.acSetBookIdFilterQuestions(data.bookId)
      }
    },

    replaceLink (link) {
      return replaceImageResize(link, {width: 285, height: 404})
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-question__slide{
  margin: 30px 0 50px;

    &__head{
      border-bottom: 1px solid #E5E5EA;
      margin-bottom: 15px;
    }
}
</style>
